import React from 'react';
import PropTypes from 'prop-types';
import IconMenu from 'material-ui/IconMenu';
import IconButton from 'material-ui/IconButton';
import NavigationExpandMoreIcon from 'material-ui/svg-icons/navigation/expand-more';
import MenuItem from 'material-ui/MenuItem';

import COLORS from '../../../theme/colors';
import './user_email_menu.scss';

export default function UserEmailMenu(props) {
  return (
    <div className="user-email-menu">
      <span>
        { props.user.email }
      </span>

      <IconMenu
        iconStyle={{ color: COLORS.white }}
        iconButtonElement={(
          <IconButton touch>
            <NavigationExpandMoreIcon />
          </IconButton>
        )}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        targetOrigin={{ horizontal: 'right', vertical: 'top' }}
      >
        <MenuItem primaryText="Sign out" onClick={props.logout} />
      </IconMenu>
    </div>
  );
}

UserEmailMenu.propTypes = {
  logout: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/app_bar_user_profile/user_email_menu/user_email_menu.jsx